module.exports = __webpack_public_path__ + "img/home-3-person-mobile.ad9cf1a8.png";